// src/redux/order/order.reducer.js
import { OrderActionTypes } from './order.types';

const INITIAL_STATE = {
  orders: [],
  loading: false,
  error: null,
  currentOrder: null
};

const orderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OrderActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
      
    case OrderActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload
      };
      
    case OrderActionTypes.SET_ORDERS:
      return {
        ...state,
        orders: action.payload || []
      };
      
    case OrderActionTypes.CREATE_ORDER:
      return {
        ...state,
        orders: [action.payload, ...state.orders],
        currentOrder: action.payload
      };
      
    case OrderActionTypes.UPDATE_ORDER:
      return {
        ...state,
        orders: state.orders.map(order =>
          order.id === action.payload.id
            ? { ...order, status: action.payload.status, updatedAt: new Date().toISOString() }
            : order
        )
      };
      
    case OrderActionTypes.CLEAR_ORDER:
      return {
        ...state,
        currentOrder: null
      };
      
    default:
      return state;
  }
};

export default orderReducer;